const CONTENT_BUTTONS_HEIGHT = 48
const CONTENT_BUTTONS_MARGIN_SMALL = 32
const CONTENT_BUTTONS_MARGIN_MEDIUM = 48

export const CONTENT_BUTTONS_SIZE_SMALL = (CONTENT_BUTTONS_HEIGHT + CONTENT_BUTTONS_MARGIN_SMALL)
export const CONTENT_BUTTONS_SIZE_MEDIUM = (CONTENT_BUTTONS_HEIGHT + CONTENT_BUTTONS_MARGIN_MEDIUM)
export const MODAL_DROPDOWN_HEIGHT = 80
export const MODAL_HEADER_HEIGHT = 60

export const MOBILE_TOP_SPACING = 40
